<template>
  <div>
    <div :class="{
        'search-bar-margin-bottom-cla': !isInPage,
        'search-bar-cla': isInPage
      }">
      <el-form ref="formValidate"
               :inline="true"
               :model="params"
               label-position="right">
        <el-form-item :label="$t('user.account')"
                      prop="username">
          <el-input v-model.trim="params.username"
                    :clearable="true"
                    style="width:200px"
                    :placeholder="this.$t('user.account')"></el-input>
        </el-form-item>
        <el-button type="primary"
                   @click="commQuery"
                   icon="el-icon-search">{{
          $t('common.search')
        }}</el-button>
      </el-form>
    </div>

    <div class="black_panel_cla">
      <div class="header-button-bar"
           :class="{ inpage_black: isInPage }">
        <ZkButtonGroup :isLoadGroupName="true"
                       @add="addUser"
                       groupName="integratedAdd"
                       :isGroup="true"></ZkButtonGroup>
      </div>

      <el-table :data="tableData"
                stripe
                style="width: 100%">
        <el-table-column prop="username"
                         :label="this.$t('login.account')"></el-table-column>
        <el-table-column :label="this.$t('common.operation')">
          <template slot-scope="scope">
            <ZkButtonGroup :isLoadGroupName="true"
                           :params="scope.row"
                           :showText="true"
                           @update="updateUser"
                           @delete="deleteUser"
                           size="mini"
                           :onlyShowText="true"
                           groupName="intergration"
                           :isGroup="true"></ZkButtonGroup>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-margin-top">
        <el-pagination background
                       @size-change="changePageSize"
                       @current-change="changePage"
                       :current-page="pager.curPage"
                       :page-size="pager.pageSize"
                       layout="total, prev, pager, next, sizes, jumper"
                       :total="pager.total"></el-pagination>
      </div>
    </div>

    <el-dialog :append-to-body="true"
               :title="dialogTitle"
               :visible.sync="dialogFormVisible"
               width="45%">
      <el-form ref="addForm"
               label-width="180px"
               :rules="rules"
               :model="form">
        <el-form-item :label="$t('user.userName')"
                      prop="username">
          <el-input :disabled="isUpdate"
                    v-model.trim="form.username"
                    autocomplete="off"
                    :placeholder="this.$t('common.inputUserName')"></el-input>
        </el-form-item>

        <el-form-item :label="$t('user.password')"
                      prop="password">
          <el-input v-model.trim="form.password"
                    autocomplete="off"
                    type="password"
                    :placeholder="this.$t('user.inputPwd')"></el-input>
        </el-form-item>

        <el-form-item :label="$t('user.confirmedPwd')"
                      prop="secondPwd">
          <el-input v-model.trim="form.secondPwd"
                    autocomplete="off"
                    type="password"
                    :placeholder="this.$t('user.input2ndPwd')"></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer"
           class="dialog-footer">
        <el-button @click="dialogFormVisible = false">{{
          $t('common.cancel')
        }}</el-button>
        <el-button type="primary"
                   @click="submitSave">{{
          $t('common.confirm')
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as accountApi from '@/services/integratedAccountApi.js'
export default {
  data () {
    let checkRepasswd = (rule, value, callback) => {
      if (!(value + '')) {
        return callback(new Error(this.$t('user.input2ndPwd')))
      } else if (value !== this.form.password) {
        return callback(new Error(this.$t('user.pwdInconsistent')))
      } else {
        callback()
      }
    }
    let rules = {
      username: [
        {
          required: true,
          message: this.$t('user.inputAccount'),
          trigger: 'blur'
        }
      ],
      password: this.validatorPasswordRule(true),
      secondPwd: [{ required: true, validator: checkRepasswd, trigger: 'blur' }]
    }
    return {
      dialogTitle: '',
      dialogFormVisible: false,
      tableData: [],
      params: {
        username: ''
      },
      isUpdate: false,
      rules,
      form: {
        id: '',
        username: '',
        password: '',
        secondPwd: ''
      }
    }
  },
  props: {
    company: {
      type: String,
      default: ''
    },
    queryByCmp: {
      type: Boolean,
      default: false
    },
    isInPage: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    company: {
      handler: function (val, oVal) {
        if (val) {
          this.params.companyId = val
          this.commQuery()
        } else {
          this.params.companyId = ''
          this.tableData = []
        }
      },
      deep: true
    }
  },
  mounted () {
    this.commQuery()
  },
  methods: {
    addUser () {
      this.dialogFormVisible = true
      this.isUpdate = false
      this.form.id = ''
      this.form.username = ''
      this.form.password = ''
      this.form.secondPwd = ''
      this.dialogTitle = this.$t('user.addUser')
      this.$nextTick(() => {
        this.clearValidate()
      })
    },
    clearValidate () {
      this.$refs.addForm.clearValidate()
    },
    updateUser (row) {
      this.isUpdate = true
      this.form.id = row.id
      this.form.username = row.username
      this.form.password = ''
      this.form.secondPwd = ''
      this.dialogTitle = this.$t('user.modifyUser')
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.clearValidate()
      })
    },
    deleteUser (row) {
      this.$confirm(
        this.$tc('user.confirmDeleteTip', 1) +
        ' ' +
        row.username +
        this.$tc('user.confirmDeleteTip', 2),
        this.$t('common.confirmDelete'),
        {
          confirmButtonText: this.$t('common.yes'),
          cancelButtonText: this.$t('common.cancel'),
          type: 'warning'
        }
      )
        .then(() => {
          accountApi
            .deleteUsers({
              id: row.id
            })
            .then(data => {
              if (data.code === '00000000') {
                this.$message({
                  type: 'success',
                  message: this.$t('common.successDelete')
                })
                this.commQuery()
              } else {
                this.$message({
                  type: 'error',
                  message: data.message
                })
              }
            })
            .catch(data => {
              this.errorMessage(data.message)
            })
        })
        .catch(() => { })
    },
    changePageSize (pageSize) {
      this.pager.pageSize = pageSize
      this.commQuery()
    },
    changePage (current) {
      this.pager.curPage = current
      this.commQuery()
    },
    commQuery () {
      if (this.queryByCmp && !this.params.companyId) {
        return false
      }
      accountApi
        .findUsers({
          params: this.params,
          pager: this.pager
        })
        .then(data => {
          if (data.code === '00000000') {
            this.tableData =
              data.payload.results.results || data.payload.results
            this.pager.curPage =
              data.payload.results.curPage || data.payload.curPage
            this.pager.total =
              data.payload.results.totalRecords || data.payload.totalRecords
            this.pager.pageSize =
              data.payload.results.pageSize || data.payload.pageSize
          } else {
            this.errorMesage(data.message)
          }
        })
        .catch(e => {
          this.errorMesage()
        })
    },
    submitSave () {
      if (this.isUpdate) {
        // 更新
        let params = JSON.parse(JSON.stringify(this.form))
        params.companyId = this.company
        delete params.secondPwd

        this.$refs.addForm.validate(valid => {
          if (valid) {
            accountApi
              .updateUsers(params)
              .then(data => {
                if (data.code === '00000000') {
                  this.commQuery()
                  this.dialogFormVisible = false
                  this.$message.success(this.$t('common.success'))
                } else {
                  this.errorMessage(data.message)
                }
              })
              .catch(data => {
                this.errorMessage()
              })
          }
        })
      } else {
        // 新增
        let params = JSON.parse(JSON.stringify(this.form))
        if (this.company) {
          params.companyId = this.company
        }
        delete params.secondPwd

        this.$refs.addForm.validate(valid => {
          if (valid) {
            accountApi
              .createUsers(params)
              .then(data => {
                if (data.code === '00000000') {
                  this.commQuery()
                  this.dialogFormVisible = false
                  this.$message.success(this.$t('common.success'))
                } else {
                  this.errorMessage(data.message)
                }
              })
              .catch(data => {
                this.errorMessage()
              })
          }
        })
      }
    }
  }
}
</script>
<style lang="less" scoped>
.inpage_black {
  padding: 0px;
  position: absolute;
  top: -45px;
  right: 5px;
}
</style>



// WEBPACK FOOTER //
// src/modules/comComponent/integratedAccountManager.vue